import { ERROR, LOADING, READY, useVisualState } from '../../../../hooks/useVisualState'
import React, { useEffect, useState } from 'react'

import Checkbox from '../../../../components/Checkbox/Checkbox'
import DateTimePicker from '../../../../components/DateTimePicker/DateTimePicker'
import { Form } from '../../../../components/Form/Form'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import MultiSelectItem from '../../../../components/MultiSelect/MultiSelectItem'
import Select from '../../../../components/Select/Select'
import SelectItem from '../../../../components/Select/SelectItem'
import TextField from '../../../../components/TextField/TextField'
import TimePicker from '../../../../components/TimePicker/TimePicker'
import { get } from '../../../../helpers/request'
import t from '../../../../helpers/i18n'

const numberValidation = (text) =>
  /^[1-9][0-9]*$/.test(text) ? false : t('validations.number_is_invalid')

const NewCompetitionStepTwo = ({ divisions, data, setFormValid }) => {
  const [[teamsState, teams], setTeams] = useVisualState()
  const [playerLimitRequired, setPlayerLimitRequired] = useState(false)
  const [reinforcements, setReinforcementsRequired] = useState(false)
  const [reinforcementsCriteria, setReinforcementCriteria] = useState()
  const [matchTimesCheck, setMatchTimesCheck] = useState(0)
  const [registrationPeriod, setRegistrationPeriod] = useState()
  const [promotions, setPromotions] = useState()
  const [demotions, setDemotions] = useState()

  useEffect(() => {
    setTeams(LOADING)
    get('/soccer/competitions/divisions/teams?q=' + JSON.stringify(divisions))
      .then((response) => {
        setTeams(READY, response)
      })
      .catch((error) => {
        setTeams(ERROR, error)
      })
  }, [setTeams, divisions])

  return (
    <div>
      <h3>{t('titles.New_competition_Competition_Settings')}</h3>
      <Form data={data} onValidityChange={setFormValid}>
        <h4>{t('titles.Team_Roster_Player_Limit')}</h4>
        <Checkbox
          initiallyChecked={playerLimitRequired}
          onChange={(checked) => setPlayerLimitRequired(checked)}
          label={t('for_check.Set_a_player_limit')}
        />
        {playerLimitRequired && (
          <TextField
            name='player_limit'
            label={t('labels.Player_limit')}
            maxLength={3}
            minLength={1}
            onValidation={numberValidation}
            required
          />
        )}

        <h4>{t('titles.Teams_in_competition')}</h4>
        <MultiSelect name='teams' label={t('labels.Teams')}>
          {teamsState === READY &&
            teams.map((team) => (
              <MultiSelectItem key={team.team_id} value={team.team_id}>
                {team.name}
              </MultiSelectItem>
            ))}
        </MultiSelect>
        <Checkbox
          initiallyChecked={reinforcements}
          onChange={(checked) => setReinforcementsRequired(checked)}
          label={t('for_check.Allow player reinforcements from other visions')}
        />
        {reinforcements && (
          <div>
            <TextField
              name='reinforcements_limit'
              label={t('labels.Reinforcements_limit')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <Select
              label={t('labels.Reinforcement_criteria')}
              onChange={(value) => setReinforcementCriteria(value)}
              required={reinforcements}
            >
              <SelectItem>- {t('select_item.Select_a_criteria')} -</SelectItem>
              <SelectItem value='older'>{t('select_item.Players_older_than')}</SelectItem>
              <SelectItem value='younger'>{t('select_item.Players_younger_than')}</SelectItem>
              <SelectItem value='divisions'>{t('select_item.Specific_divisions')}</SelectItem>
            </Select>
            {reinforcementsCriteria === 'older' && (
              <TextField
                name='reinforcements_older_age'
                label={t('labels.Age_older_than')}
                maxLength={3}
                minLength={1}
                onValidation={numberValidation}
                required
              />
            )}
            {reinforcementsCriteria === 'younger' && (
              <TextField
                name='reinforcements_younger_age'
                label={t('labels.Age_younger_than')}
                maxLength={3}
                minLength={1}
                onValidation={numberValidation}
                required
              />
            )}
            {reinforcementsCriteria === 'divisions' && (
              <MultiSelect
                name='reinforcements_division'
                label={t('labels.Division(s)')}
              >
                <MultiSelectItem>{t('select_item.Division_A')}</MultiSelectItem>
                <MultiSelectItem>{t('select_item.Division_B')}</MultiSelectItem>
              </MultiSelect>
            )}
          </div>
        )}

        <h4>{t('titles.Competition_Duration')}</h4>
        <DateTimePicker
          name='opening_date'
          label={t('labels.Competition_opening_date')}
        />
        <DateTimePicker
          name='closing_date'
          label={t('labels.Competition_closing_date')}
        />

        <h4>{t('titles.Match Weekdays and Day Times')}</h4>
        {[
          t('days.Mondays'),
          t('days.Tuesdays'),
          t('days.Wednesdays'),
          t('days.Thursdays'),
          t('days.Fridays'),
          t('days.Saturdays'),
          t('days.Sundays')
        ].map((title, weekday) => (
          <div key={weekday}>
            <Checkbox
              initiallyChecked={matchTimesCheck & (1 << weekday)}
              onChange={(checked) =>
                setMatchTimesCheck(matchTimesCheck | (1 << weekday))
              }
              label={title}
            />
            {(matchTimesCheck & (1 << weekday)) > 0 && (
              <div>
                <TimePicker
                  name={'first_match_time_' + weekday}
                  label={t('labels.Time_of_first_match')}
                />
                <TimePicker
                  name={'last_match_time_' + weekday}
                  label={t('labels.Time_of_last_match')}
                />
              </div>
            )}
          </div>
        ))}

        <h4>{t('titles.Registration_Period')}</h4>
        <Checkbox
          initiallyChecked={registrationPeriod}
          onChange={(checked) => setRegistrationPeriod(checked)}
          label={t('for_check.Set_a_registration_period')}
        />
        {registrationPeriod && (
          <div>
            <DateTimePicker
              name='registration_opening_date'
              label={t('labels.Registration_opening_date')}
            />
            <DateTimePicker
              name='registration_closing_date'
              label={t('labels.Registration_closing_date')}
            />
          </div>
        )}

        <h4>{t('titles.Venues')}</h4>
        <MultiSelect name='venues' label={t('labels.Venues')}>
          <MultiSelectItem value='5'>{t('select_item.Venue_A')}</MultiSelectItem>
          <MultiSelectItem value='6'>{t('select_item.Venue_B')}</MultiSelectItem>
          <MultiSelectItem value='7'>{t('select_item.Venue_C')}</MultiSelectItem>
          <MultiSelectItem value='8'>{t('select_item.Venue_D')}</MultiSelectItem>
        </MultiSelect>

        <h4>{t('titles.Competition_Structure')}</h4>
        <Select
          name='competition_structure'
          label={t('labels.Competition_Structure')}
          required
        >
          <SelectItem>- {t('select_item.Select_a_preset')} -</SelectItem>
          <SelectItem value='regular'>{t('select_item.Only_a_regular_phase')}</SelectItem>
          <SelectItem value='regular+playoffs'>{t('select_item.Regular_phase_Playoffs_phase')}</SelectItem>
          <SelectItem value='regular+2playoffs'>{t('select_item.Regular_phase_Two_playoffs_phase')}</SelectItem>
          <SelectItem value='playoffs'>{t('select_item.Only_playoffs_phase')}</SelectItem>
          <SelectItem value='championship'>{t('select_item.Championship_phase')}</SelectItem>
        </Select>

        <h4>{t('titles.Statistics_generation')}</h4>
        <Select
          name='statistics_generation'
          label={t('labels.Statistics_generation')}
          required
        >
          <SelectItem>- {t('select_item.Select_an_option')} -</SelectItem>
          <SelectItem value='regular'>{t('select_item.Only_regular_phase')}</SelectItem>
          <SelectItem value='regular+playoffs'>{t('select_item.Regular_phase_All_playoffs_phases')}</SelectItem>
        </Select>

        <h4>{t('titles.Divisional promotions')}</h4>
        <Checkbox
          initiallyChecked={promotions}
          onChange={(checked) => setPromotions(checked)}
          label={t('for_check.Promotions')}
        />
        {promotions && (
          <div>
            <Select name='promotion_division' label={t('labels.Division')} required>
              <SelectItem>- {t('select_item.Select_a_division')} -</SelectItem>
              <SelectItem value='a'>{t('select_item.Division_A')}</SelectItem>
              <SelectItem value='b'>{t('select_item.Division_B')}</SelectItem>
            </Select>
            <Select
              name='promotion_periodicity'
              label={t('labels.Periodicity')}
              required
            >
              <SelectItem>- {t('select_item.Select_a_periodicity')} -</SelectItem>
              <SelectItem value='mid'>{t('select_item.Every_mid_season')}</SelectItem>
              <SelectItem value='one'>{t('select_item.Every_season')}</SelectItem>
              <SelectItem value='two'>{t('select_item.Every_two_seasons')}</SelectItem>
            </Select>
          </div>
        )}
        <Checkbox
          initiallyChecked={demotions}
          onChange={(checked) => setDemotions(checked)}
          label={t('for_check.Demotions')}
        />
        {demotions && (
          <div>
            <Select name='demotion_division' label={t('labels.Division')} required>
              <SelectItem>- {t('select_item.Select_a_division')} -</SelectItem>
              <SelectItem value='a'>{t('select_item.Division_A')}</SelectItem>
              <SelectItem value='b'>{t('select_item.Division_B')}</SelectItem>
            </Select>
            <Select
              name='demotion_periodicity'
              label={t('labels.Periodicity')}
              required
            >
              <SelectItem>- {t('select_item.Select_a_periodicity')} -</SelectItem>
              <SelectItem value='mid'>{t('select_item.Every_mid_season')}</SelectItem>
              <SelectItem value='one'>{t('select_item.Every_season')}</SelectItem>
              <SelectItem value='two'>{t('select_item.Every_two_seasons')}</SelectItem>
            </Select>
          </div>
        )}
      </Form>
    </div>
  )
}

export default NewCompetitionStepTwo
